import React from "react";
import ProgramTestSubmissions from "./ProgramTestSubmissions";

// Homework copies use the same correction screen as tests: each answer with
// its verdict, points the teacher can adjust, then "Save review".
export default function HomeworkSubmissions() {
  return <ProgramTestSubmissions kind="homework" />;
}
